import { ADD_CARD, DELETE_CARD } from '../actions/cardActions';

const initialState = {
  cards: [
    
  ],
};

const cardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CARD:
      return {
        ...state,
        cards: [...state.cards, action.payload],
      };
    case DELETE_CARD:
      return {
        ...state,
        cards: state.cards.filter((card) => card.id !== action.payload),
      };
      case 'SET_CARDS':
        return {
          ...state,
          cards: action.payload,
        };
        case 'LOAD_CARDS':
      return { ...state, cards: action.payload };
    
    
    default:
      return state;
  }
};

export default cardReducer;
